import React from "react";
import "./user-snackbar.m.css";

const UserSnackbar = ({ user, onLogout, onClose }) => {
  if (!user) return null;
  const idnt = user.emails?.[0] || user.phoneNumbers?.[0] || "User";
  return (
    <div styleName="snackbar-wrapper">
      <div styleName="snackbar-container">
        <div styleName="message">Logged in as <span styleName="identifier">{idnt}</span>. <button styleName="logout-btn" onClick={onLogout}>Logout</button></div>
        <button styleName="close-btn" onClick={onClose} aria-label="Close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg></button>
      </div>
    </div>
  );
};
export { UserSnackbar };
